<script setup lang="ts">
import { computed, ref } from 'vue'
import AuthModal from '../components/auth/AuthModal.vue'
import HomeSlideshow from '../components/home/HomeSlideshow.vue'
import FeatureList from '../components/home/FeatureList.vue'
import FeatureExplorer from '../components/home/FeatureExplorer.vue'
import FeatureVideos from '../components/home/FeatureVideos.vue'
import Testimonials from '../components/home/Testimonials.vue'
import GetInTouch from '../components/home/GetInTouch.vue'
import ClientShowcase from '../components/home/ClientShowcase.vue'
import Footer from '../components/layout/home/Footer.vue'
import ChatFab from '../components/chat/ChatFab.vue'
import { tokenManager } from '../api/utils/tokenManager'
import router from '../router'

const showAuthModal = ref(false)

const messaage = computed(() => tokenManager.getMessage())

const handleGetStarted = () => {
  router.push('/register')
}

</script>

<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <!-- Hero Section -->
    <div class="py-12 px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Complete Business Management Solution
          </h1>
          <p class="text-lg text-gray-600 dark:text-gray-400 mb-8">
            Streamline your business with our integrated POS, Inventory, and Accounting system
          </p>
          <div class="mb-8" v-if="messaage == 'new_company_registered'">
            <div class="w-20 h-20 bg-green-100 dark:bg-green-900/50 rounded-full flex items-center justify-center text-4xl mx-auto mb-4">
              ✓
            </div>
            <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Registration Completed Successfully!
            </h2>
            <p class="text-gray-600 dark:text-gray-400 mb-4">
              An activation email has been sent to you, please remember to check spam folder too.
            </p>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              Please check your email and click the activation link to complete your registration.
            </p>
          </div>
          <div v-else-if="messaage == 'company_registration_completed'" class="mt-8 text-center">
            <div class="w-16 h-16 bg-green-100 dark:bg-green-900/50 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
              ✓
            </div>
            <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              Setup Complete!
            </h2>
            <p class="text-gray-600 dark:text-gray-400 mb-6">
              Your company has been successfully created. You can now log in to your account.
            </p>
            <button
              @click="showAuthModal = true"
              class="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Log In to Continue
            </button>
        </div>
        <div v-else-if="messaage == 'user_email_activated'" class="mt-8 text-center">
            <div class="w-16 h-16 bg-green-100 dark:bg-green-900/50 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
              ✓
            </div>
            <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              Activation Complete!
            </h2>
            <p class="text-gray-600 dark:text-gray-400 mb-6">
              Your email verified and activated has been successfully. You can now log in to your account.
            </p>
            <button
              @click="showAuthModal = true"
              class="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Log In to Continue
            </button>
        </div>
          <div class="flex justify-center gap-4" v-else>
            <button
              @click="handleGetStarted"
              class="px-6 py-3 text-base font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Get Started
            </button>
            <button
              @click="showAuthModal = true"
              class="px-6 py-3 text-base font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
            >
              Sign In
            </button>
          </div>
        </div>

        <!-- Slideshow -->
        <HomeSlideshow />
      </div>
    </div>

    <!-- Features -->
    <FeatureList />
    <FeatureExplorer />
    <FeatureVideos />

    <!-- Testimonials -->
    <Testimonials />

    <!-- Get in Touch -->
    <GetInTouch />

    <!-- Client Showcase -->
    <ClientShowcase />

    <!-- Footer -->
    <Footer />

    <!-- Chat FAB -->
    <ChatFab />

    <!-- Modals -->
    <AuthModal 
      v-if="showAuthModal"
      @close="showAuthModal = false"
    />
    
  </div>
</template>